import React, { Component } from 'react';
import './all.scss';
import Header from './header';
import PortfolioList from './portfolioList';
import Footer from './footer';
import portfolioListData from './portfolioListData';

class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
			portfolioList: portfolioListData
		}
	}
	render() {
		return (
			<div className="Root">
				<Header />
				<PortfolioList items={this.state.portfolioList} />			
				<Footer />			
			</div>  
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js